import { useEffect } from 'react';
import { initializePostHog, isPostHogEnabled, resetPostHog } from '@/services/posthog.ts';

const usePostHog = (userEmail?: string) => {
  useEffect(() => {
    if (!isPostHogEnabled()) {
      console.warn('PostHog is disabled because no API key is configured or development mode is active.');
      return;
    }

    void initializePostHog(userEmail);

    return () => {
      void resetPostHog();
    };
  }, [userEmail]);
};

export default usePostHog;
